export {};
//# sourceMappingURL=type-options.interface.js.map


//////////////////
// WEBPACK FOOTER
// ./~/class-transformer/esm5/interfaces/decorator-options/type-options.interface.js
// module id = 794
// module chunks = 3